import { BaseSyntheticEvent, useContext } from "react";
import { IoAddCircleOutline } from "react-icons/io5";
import { AuthContext } from "../../../../contexts/Authentication/AuthContext";
import EditButton from "./EditButton";
import RemoveButton from "./RemoveButton";
import ViewButton from "./ViewButton";
import "../styles.css";
import DuplicateButton from "./DuplicateButton";
import ExportButton from "./ExportButton";

interface CardTowerAvaliableProps {
  index: number;
  name: string;
  id: string;
  template?: boolean;
}

function MouseOver(event: BaseSyntheticEvent) {
  event.target.style.cursor = "pointer";
}

export default function UserPage({
  index,
  name,
  id,
  template,
}: CardTowerAvaliableProps) {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <div key={index} className="user-page users-page" id={"user-page" + id}>
      <div className="user-page-div">
        {!template ? (
          <>
            <div>
              <h4>{name ? name : "Sem título"}</h4>
            </div>
            <div className="display-flex-space-around px-3">
              <ViewButton id={id} />
              {isAuthenticated ? <EditButton id={id} /> : <></>}
              {isAuthenticated ? ( <DuplicateButton id={id} name={name} /> ) : (<></>)}
              {isAuthenticated ? <ExportButton id={id} /> : <></>}
              {isAuthenticated ? <RemoveButton id={id} /> : <></>}
            </div>
          </>
        ) : (
          <>
            <div id="title_templates">
              <div>{name ? name : "Sem título"}</div>
            </div>
            <div className="display-flex-space-around px-3">
              {isAuthenticated ? (
                <IoAddCircleOutline size={50} onMouseOver={MouseOver} />
              ) : (
                ""
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
